import { string } from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import find from 'lodash/find';
import S7Image from 'yoda-core-components/lib/components/S7Image/S7Image';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import getSelectedProductImages from 'yoda-site-components/lib/selectors/ProductImageSelector';
import { selectProductDetailsWrapper } from 'yoda-site-components/lib/selectors/PdpNameSpaceSelector';

const ProductDescriptionSlider = (props) => {
    const productImages = useSelector((state) => getSelectedProductImages(false)(state));
    const productDetails = useSelector((state) => selectProductDetailsWrapper(false)(state));
    const primaryImage =
        find(productImages, (image) => image.type === 'PRIMARY' || image.type === undefined) || {};
    return (
        <>
            <div className={dt(['p-2', 'flex'])}>
                <div className={dt(['h-24', 'w-24', 'flex-shrink-0', 'mt-auto'])}>
                    <S7Image
                        data-automation-id="at-product-image"
                        src={primaryImage?.url}
                        alt="Product Image"
                    />
                </div>
                <div
                    className={dt([
                        'font-open-sans-semibold',
                        'text-lg',
                        'leading-7',
                        'text-black',
                        'flex',
                        'items-center',
                    ])}
                    id="productTitle"
                >
                    {productDetails?.name}
                </div>
            </div>
            <div
                className={dt(['smOnly:h-5/6', 'overflow-y-auto', 'pb-5', 'px-6'])}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: props?.productDescription,
                }}
                id="productDescription"
            />
        </>
    );
};

ProductDescriptionSlider.defaultProps = {
    productDescription: '',
};

ProductDescriptionSlider.propTypes = {
    productDescription: string,
};

export default ProductDescriptionSlider;
